import { Checkbox, TextField, Paper, styled } from "@mui/material";
import { ButtonEdit } from '../../../../components/general/mini_components';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import dayjs from "dayjs";

import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button, Container, Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";


import { interventionFormSchema, type InterventionFormData } from "./schemas";
import { useState, useMemo, useRef, useEffect } from "react";
import { Alert, Snackbar } from "@mui/material";

/*
TODO: Solve update problem -> When I click on an already existing MatrixForm and I want to update a submission (a row) and click the save intervention button, it doesn't work. I have to compare the format of the data that is sent when I create a new submission and the format of the data that is sent when I update a submission. Another thing I could do is to compare the data that is being sent now and the data that was sent in the commit fe6bb8f6a7d32b4dfe4f9a503dd195fdaf97863a (This will work for sure)
TODO: Implementation checkboxes editing MatrixForm (UI problems). The problem is that I cannot make two functionalities work (clicking the checkboxes and adapting the checkboxes to the current selection when I change the selection from one row to another)
TODO: DateFormat dateToFullDateString function (src/utils/index.jsx) -> I have to adapt the date format to the local language that the user selects, I cannot use the international format
TODO: Review the whole functionality of the component
*/


export function MatrixForm({ survey, submissions, callbackSurveyCompleted, isVisualizingMode = false }: { 
    survey: any, 
    submissions?: any[], 
    callbackSurveyCompleted: (payload:any, editedSubmissionId?: number) => void, 
    isVisualizingMode?: boolean}) {
    
    if (!survey || !survey.sections || survey.sections.length === 0) {
        return (
            <Container maxWidth="xl" sx={{ py: 4 }}>
                <Alert severity="error" sx={{ mb: 2 }}>
                    <Typography variant="h6" gutterBottom>
                        Survey Not Available
                    </Typography>
                    <Typography>
                        The survey data is missing or invalid.
                    </Typography>
                </Alert>
            </Container>
        );
    }
    
    // Extract the survey name for display
    const surveyName = survey?.name || 'Survey';
    
    const [snackbar, setSnackbar] = useState<{
        open: boolean;
        message: string;
        severity: "success" | "error";
    }>({
        open: false,
        message: "",
        severity: "success"
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isEditActive, setIsEditActive] = useState(false);
    const [editedSubmissionId, setEditedSubmissionId] = useState<number | null>(null);

    // Add this state to track which row is being edited
    const [editingRowId, setEditingRowId] = useState<number | null>(null);

    const {
        register,
        handleSubmit,
        setValue,
        control,
        formState: { errors },
        watch,
    } = useForm<InterventionFormData>({
        resolver: zodResolver(interventionFormSchema),
        mode: "onChange",
        defaultValues: {
            date: new Date(),
            timeIn: dayjs().format("HH:mm"),
            timeOut: "",
            seenAt: "",
            staffInitials: "",
            referredTo: "",
            supervised: "",
        }
    });

    

    useEffect(() => {
        if (Object.keys(errors).length > 0) {
            console.error("Form validation errors:", errors);
        }
    }, [errors]);


    // useMemo: Cashed value. Pre-register all dynamic fields to avoid registration issues  //Because the number and names of fields are unknown at compile time
    // Filter out sections that have no fields before processing
    const dynamicFields = useMemo(() => {
        return (survey?.sections || [])
            .filter((section: any) => section?.fields && section.fields.length > 0)
            .flatMap((section: any, sectionIndex: number) =>
                sectionIndex > 0 ? (section?.fields || []).filter((field: any) => field && (field.name || field.id)).map((field: any, fieldIndex: number) => {
                    const rawFieldName = field?.name || field?.id || `field-${sectionIndex}-${fieldIndex}`;
                    const fieldName = `${sectionIndex}_${rawFieldName.replace(/[^a-zA-Z0-9_]/g, '_').replace(/^[0-9]/, '_$&')}`;
                    return { 
                        fieldName, 
                        rawFieldName, 
                        sectionIndex, 
                        fieldIndex,
                        sectionName: section?.name,
                        sectionId: section?.id,
                        fieldId: field?.id,
                        fieldLabel: field?.label
                    };
                }) : []
            );
    }, [survey?.sections]);


    const isMountedRef = useRef(true);                                      //To track the component and to check if it is still mounted

    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);


    const onSubmit = async (data: InterventionFormData) => {
        setIsSubmitting(true);
        try {

            console.log("Data:", data);

            const allValues = watch();                  //Static and dynamic fields

            const checkboxValues = dynamicFields.map(({ fieldName, rawFieldName, sectionName, sectionId, fieldId, fieldLabel }:any) => ({
                id: rawFieldName,
                section: sectionName,
                sectionId: sectionId,
                fieldId: fieldId,
                label: fieldLabel,
                checked: (allValues as any)[fieldName] || false
            }));

            let alertMessage = "";
            for (var i = 0; i < checkboxValues.length; i++) {
                console.log("Checkbox value:", checkboxValues[i]);

                alertMessage = alertMessage + "Value of " + checkboxValues[i].id + ": " + checkboxValues[i].checked + "\n";
            }





            //alert(alertMessage);

            /* 
            3 timestamps: The choosen day 00:00:00, the time in, and the time out


            let data.date = "2025-09-30"
            let data.timeIn = "02:00 AM"
            let c; 


            dayjs(`${data.date}T${data.timeIn}`).valueOf(),
            
            What about this?

            */

            console.log("Hello world");



            const fieldValues = [
                dayjs(data.date).valueOf(),
                dayjs(`${dayjs(data.date).format('YYYY-MM-DD')}T${data.timeIn}`).valueOf(),
                dayjs(`${dayjs(data.date).format('YYYY-MM-DD')}T${data.timeOut}`).valueOf(),
                data.seenAt,
                data.staffInitials,
                data.referredTo,
                data.supervised
            ];


            console.log("Field values:", fieldValues);
            console.log("data.timeOut:", data.timeOut);
            console.log("data.timeIn:", data.timeIn);


            const surveyRecords = [
                ...survey.sections[0].fields.map((field: any, index: number) => ({
                    surveyField: {
                        id: field.id,
                        name: field.name
                    },
                    value: typeof fieldValues[index] === 'number' ? String(fieldValues[index]) : (fieldValues[index] || "")
                })),
                ...checkboxValues.map((checkboxValue:any) => ({
                    surveyField: {
                        id: checkboxValue.fieldId,
                        name: checkboxValue.label
                    },
                    value: String(checkboxValue.checked)
                }))

            ];


            console.log("Post object:", surveyRecords);
            console.log("About to call callback...");

            //alert("");


            if (editedSubmissionId) {
                callbackSurveyCompleted(surveyRecords, editedSubmissionId);
            }
            else {
                callbackSurveyCompleted(surveyRecords);
            }

            console.log("Callback completed successfully");

            //alert("");




            // const response = await fetch("/api/interventions", {
            //     method: "POST",
            //     headers: { "Content-Type": "application/json" },
            //     body: JSON.stringify(data),


            //     //Files I have to analyze. FillSurvey.tsx and form.jsx
            //     //Things to ask. How to build build surveyRecords. I already have the id and the value (boolean), are the other fields necessary?
            //     //ReduxForm: It adds more complex lines of code, and it is not maintainable. Performance issues with frequent re-renders. The AI insisted that it is not a good idea
            //     //


                





            // });

            // if (!response.ok) throw new Error("Failed to save intervention");


            if (isMountedRef.current) {
                setSnackbar({
                    open: true,
                    message: "hospital.matrix-form-saved-successfully",
                    severity: "success"
                });
            }

        } catch (error) {
            if (isMountedRef.current) {
                setSnackbar({
                    open: true,
                    message: "hospital.matrix-form-saved-error",
                    severity: "error"
                });
            }
        } finally {
            if (isMountedRef.current) {
                setIsSubmitting(false);
            }
        }
    };

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };
      
    const date = watch("date");

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Container maxWidth="xl" sx={{ py: 4 }}>
                <Typography variant="h4" component="h1" align="center" gutterBottom>
                    DATA CAPTURE FORM {surveyName}
                </Typography>
                <form onSubmit={(e) => {
                    console.log("Form submit event triggered");
                    console.log("Is edit active:", isEditActive);
                    console.log("Form errors:", errors);
                    console.log("Form data:", watch());
                    handleSubmit(onSubmit)(e)}}>
                    <MatrixFormView
                        register={register}
                        setValue={setValue}
                        watch={watch}
                        control={control}
                        errors={errors}
                        date={date}
                        disabled={isSubmitting}
                        survey={survey}
                        submissions={submissions}
                        dynamicFields={dynamicFields}
                        isVisualizingMode={isVisualizingMode}
                        isEditActive={isEditActive}
                        setIsEditActive={setIsEditActive}
                        setEditedSubmissionId={setEditedSubmissionId}
                    />
                    <div style={{ marginTop: "24px", display: (isVisualizingMode && !isEditActive) ? 'none' : 'flex', justifyContent: "flex-end",  }}>
                        <Button
                            type="submit"
                            variant="contained"
                            disabled={isSubmitting}
                            // onClick={(e) => {
                            //     console.log("Save button clicked");
                            //     console.log("Form errors:", errors);
                            //     console.log("Is edit active:", isEditActive);
                            //     console.log("Edited submission ID:", editedSubmissionId);
                                
                            //     // If there are validation errors, log them
                            //     if (Object.keys(errors).length > 0) {
                            //         console.error("Form validation errors:", errors);
                            //     }
                            // }}
                        >
                            {isSubmitting ? "Saving..." : "Save Intervention"}
                        </Button>
                    </div>
                </form>
                <Snackbar
                    open={snackbar.open}
                    autoHideDuration={6000}
                    onClose={handleCloseSnackbar}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                >
                    <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
                        {snackbar.message}
                    </Alert>
                </Snackbar>
            </Container>
        </LocalizationProvider>
    );
}


interface InterventionGridProps {
    register: any;
    setValue: any;
    watch: any;
    control: any; 
    errors?: any;
    disabled?: boolean;
    date: Date;
    survey: any;
    submissions?: any[];
    dynamicFields: any[];
    isVisualizingMode?: boolean;
    isEditActive: boolean;
    setIsEditActive: (value: boolean) => void;
    setEditedSubmissionId: (id: number | null) => void;
}

const StyledPaper = styled(Paper)(({ theme }) => ({
    overflowX: "auto",
    "& .vertical-header": {
        writingMode: "vertical-rl",
        transform: "rotate(180deg)",
        whiteSpace: "nowrap",
        padding: "0.5rem 0",
        minHeight: "120px",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto",
        width: "100%",
    },
    "& .checkmark": {
        fontSize: "12px",
        color: theme.palette.text.primary,
    },
    "& td, & th": {
        border: `1px solid ${theme.palette.divider}`,
    },
    "& th": {
        backgroundColor: theme.palette.background.default,
    },
    "& .clinical-header": {
        backgroundColor: theme.palette.primary.light,
    },
    "& .psychological-header": {
        backgroundColor: theme.palette.success.light,
    },
    "& .social-header": {
        backgroundColor: theme.palette.warning.light,
    },
    "& table td:first-child": {
        backgroundColor: theme.palette.background.default + " !important",
        border: "none !important",
        //background: "transparent !important",
    },
    "& table th:first-child": {
        backgroundColor: theme.palette.background.default + " !important",
        border: "none !important",
        //background: "transparent !important",
    }
}));
//28818 & 28820. The section field is an array of multiple fields. I have to analyze that later
//className="clinical-header". I removed this
//className="social-header". I removed this as well
export function MatrixFormView({ register, setValue, watch, control, errors, disabled = false, date, survey, submissions, dynamicFields, isVisualizingMode, isEditActive, setIsEditActive, setEditedSubmissionId }: InterventionGridProps) {

    const [editingRowId, setEditingRowId] = useState<number | null>(null);

    useEffect(() => {
        if (editingRowId && submissions) {
            const currentSubmission = submissions.find(sub => sub.id === editingRowId);
            if (currentSubmission?.surveyRecords) {
                // Clear all checkbox values first
                dynamicFields.forEach(field => {
                    setValue(field.fieldName, false);
                });
                
                // Populate with current submission data
                currentSubmission.surveyRecords.forEach((record: any) => {
                    const dynamicField = dynamicFields.find(df => df.fieldId === record.surveyField?.id);
                    if (dynamicField) {
                        setValue(dynamicField.fieldName, record.value === "true");
                    }
                });
            }
        }
    }, [editingRowId, submissions, dynamicFields, setValue]);

    function isValidTimestamp(value: any) {
        const str = String(value);
        
        // Check if all digits and length is 10 (seconds) or 13 (milliseconds)
        if (!/^\d+$/.test(str) || (str.length !== 10 && str.length !== 13)) {
          return false;
        }
        
        // Convert to number and parse with dayjs
        const timestamp = Number(str);
        const parsed = dayjs(timestamp);
        
        return parsed.isValid();
    }

    const getSectionColorClass = (index: number) => {
        const colorClasses = [
            'clinical-header',      
            'psychological-header', 
            'social-header',        
            'clinical-header'       
        ];
        return colorClasses[index % 3];
    };
    
    return (
        <StyledPaper>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                    <tr>   
                        {/* <th colSpan={7}></th> */}
                        <th></th>

                        {(survey?.sections || [])
                            .filter((section: any) => section?.fields && section.fields.length > 0)
                            .map((section: any, index: number) => (
                                <th colSpan={section?.fields?.length || 1} key={`section-group-${index}`} className={index > 0 ? getSectionColorClass(index - 1) : ''} style={{ padding: "8px", textAlign: "center", fontWeight: "bold" }}>
                                    {section?.name}
                                </th>
                            ))}
                    </tr>
                    <tr>
                        {/* Header cells with vertical text */}

                        <th></th>
                        {(survey?.sections || [])
                            .filter((section: any) => section?.fields && section.fields.length > 0)
                            .flatMap((section: any, sectionIndex: number) => (
                                (section?.fields || []).map((field: any, fieldIndex: number) => (
                                    <th key={`section-${sectionIndex}-field-${fieldIndex}`}
                                        className={sectionIndex > 0 ? getSectionColorClass(sectionIndex - 1) : ''}>
                                        <div className="vertical-header">{field?.label}</div>
                                    </th>
                                ))
                            ))}
                    </tr>
                </thead>
                <tbody>
                    {/* Sample data rows */}
                    {console.log("MatrixForm - isVisualizingMode:", isVisualizingMode)}
                    {console.log("MatrixForm - submissions:", submissions)}



                    {(submissions || []).map((submission: any, submissionIndex: number) => (

                    //{(submissions || []).filter((submission: any) => !isVisualizingMode || submission.id === currentSubmissionId).map((submission: any, submissionIndex: number) => (


                        <tr key={`submission-${submissionIndex}`}>

                            <td style={{ textAlign: 'center', padding: '8px' }}>
                                {isVisualizingMode && (<ButtonEdit 
                                    onClick={() => {
                                        console.log('Edit submission:', submission.id);

                                        setEditedSubmissionId(submission.id);
                                        setEditingRowId(submission.id); // Track which row is being edited
                                        setIsEditActive(true);


                                        // If already editing this row, do nothing
                                        if (editingRowId === submission.id) {
                                            return;
                                        }


                                        // dynamicFields.forEach(field => {
                                        //     setValue(field.fieldName, false);
                                        // });

                                        

                                        if (submission.surveyRecords) {
                                            submission.surveyRecords.forEach((record: any) => {
                                                const fieldId = record.surveyField?.id;
                                                const value = record.value;

                                                //console.log("Field ID:", fieldId, "Value:", value);
                                                
                                                // Set text fields
                                                switch (fieldId) {
                                                    case survey.sections[0].fields[0].id:
                                                        setValue("date", new Date(Number(value)));
                                                        break;
                                                    case survey.sections[0].fields[1].id:
                                                        setValue("timeIn", dayjs(Number(value)).format("HH:mm"));
                                                        break;
                                                    case survey.sections[0].fields[2].id:
                                                        setValue("timeOut", dayjs(Number(value)).format("HH:mm"));
                                                        break;
                                                    case survey.sections[0].fields[3].id:
                                                        setValue("seenAt", value);
                                                        break;
                                                    case survey.sections[0].fields[4].id:
                                                        setValue("staffInitials", value);
                                                        break;
                                                    case survey.sections[0].fields[5].id:
                                                        setValue("referredTo", value);
                                                        break;
                                                    case survey.sections[0].fields[6].id:
                                                        setValue("supervised", value);
                                                        break;
                                                }
                                                // Set checkbox fields
                                                const dynamicField = dynamicFields.find(df => df.fieldId === fieldId);
                                                if (dynamicField) {
                                                    //console.log("Setting checkbox:", dynamicField.fieldName, "to", value === "true");
                                                    setValue(dynamicField.fieldName, value === "true");
                                                }
                                            });

                                            setTimeout(() => {
                                                    // This ensures the form state is updated
                                                }, 0);
                                            
                                        }

                                        



                

                                    }}
                                    size="small"
                                />)}
                            </td>
                
                            
                            {(survey?.sections || [])
                                .filter((section: any) => section?.fields && section.fields.length > 0)
                                .flatMap((section: any, sectionIndex: number) => (
                                    (section?.fields || []).map((field: any, fieldIndex: number) => {
                                        // Find submission record for this field
                                        const record = submission?.surveyRecords?.find((record: any) => 
                                            record.surveyField?.id === field.id
                                        );
                                        const value = record?.value;

                                        // If this row is being edited, show input fields
                                        if (editingRowId === submission.id) {
                                            if (sectionIndex === 0) {
                                                if (fieldIndex === 0) {
                                                    return <td key={`field-${field.id}`} style={{ padding: "8px" }}>
                                                        <DatePicker
                                                            value={dayjs(Number(value))}
                                                            onChange={(newDate) => setValue("date", newDate?.toDate())}
                                                            disabled={disabled}
                                                            format="YYYY-MM-DD"
                                                            slotProps={{
                                                                textField: { size: "small", fullWidth: true }
                                                            }}
                                                        />
                                                    </td>;
                                                }
                                                else if (fieldIndex === 1 || fieldIndex === 2) {
                                                    return <td key={`field-${field.id}`} style={{ padding: "8px" }}>
                                                        <TimePicker
                                                            value={dayjs(`2024-01-01T${isValidTimestamp(value) ? dayjs(Number(value)).format('HH:mm') : '00:00'}:00`)}
                                                            onChange={(newTime) => setValue(fieldIndex === 1 ? "timeIn" : "timeOut", newTime?.format("HH:mm") || "")}
                                                            disabled={disabled}
                                                            ampm={false}
                                                            slotProps={{
                                                                textField: { size: "small", fullWidth: true }
                                                            }}
                                                        />
                                                    </td>;
                                                }
                                                else {

                                                    const fieldNames = ["seenAt", "staffInitials", "referredTo", "supervised"];

                                                    //console.log("Field ID:", field.id, "Value:", value, "Field Index:", fieldIndex);

                                                    return <td key={`field-${field.id}`} style={{ padding: "8px" }}>
                                                        <TextField
                                                            name={fieldNames[fieldIndex - 3]}
                                                            size="small"
                                                            disabled={disabled}
                                                            value={watch(fieldNames[fieldIndex - 3]) || ""}
                                                            onChange={(e) => setValue(fieldNames[fieldIndex - 3], e.target.value)}
                                                            fullWidth
                                                        />
                                                    </td>;
                                                }
                                            }
                                            else {
                                                // For checkbox fields
                                                return <td key={`field-${field.id}`} style={{ textAlign: "center" }}>
                                                    <Controller
                                                        name={`${sectionIndex}_${field.name}`}
                                                        control={control}
                                                        defaultValue={false}
                                                        render={({ field }) => (
                                                            <Checkbox
                                                                {...field}
                                                                checked={field.value || false}
                                                                disabled={disabled}
                                                                size="small"
                                                            />
                                                        )}
                                                    />
                                                </td>;
                                            }
                                        }
                                        
                                        // Original display logic for non-editing rows
                                        else {

                                            if (sectionIndex === 0) {
                                                if (fieldIndex === 0) {
                                                    return <td key={`field-${field.id}`} className="border border-gray-300 p-1 text-xs text-center">
                                                        {isValidTimestamp(value) ? dayjs(Number(value)).format('YYYY-MM-DD') : "Not a timestamp"}
                                                    </td>;
                                                }
                                                else if (fieldIndex === 1 || fieldIndex === 2) {
                                                    return <td key={`field-${field.id}`} className="border border-gray-300 p-1 text-xs text-center">
                                                        {isValidTimestamp(value) ? dayjs(Number(value)).format('HH:mm') : "Not a timestamp"}
                                                    </td>;
                                                }
                                                else {
                                                    return <td key={`field-${field.id}`} className="border border-gray-300 p-1 text-xs text-center">{value}</td>;
                                                }
                                            }
    
                                            if (value === "false" || value == undefined) {
                                                return <td key={`field-${field.id}`} className="border border-gray-300 p-1 text-xs text-center"></td>;
                                            }
                                            
                                            return <td key={`field-${field.id}`} className="border border-gray-300 p-1 text-xs text-center">✓</td>;
                                        }
                                        
                                    })
                                ))}
                            
                        </tr>

                    ))}
                    
                    {/* Input row */}
                    <tr style={{ display: isVisualizingMode ? 'none' : 'table-row' }}>

                        <td></td>
                    
                        <td style={{ padding: "8px" }}>
                            <DatePicker
                                value={dayjs(date)}
                                onChange={(newDate) => setValue("date", newDate?.toDate())}
                                disabled={disabled}
                                format="YYYY-MM-DD"
                                slotProps={{
                                    textField: {
                                        size: "small",
                                        fullWidth: true
                                    }
                                }}
                            />
                        </td>
                        <td style={{ padding: "8px" }}>
                            <TimePicker
                                value={dayjs(`2024-01-01T${watch("timeIn") || "00:00"}:00`)}
                                onChange={(newTime) => setValue("timeIn", newTime?.format("HH:mm") || "")}
                                disabled={disabled}
                                ampm={false}
                                slotProps={{
                                    textField: {
                                        size: "small",
                                        fullWidth: true
                                    }
                                }}
                            />
                        </td>
                        <td style={{ padding: "8px" }}>
                            <TimePicker
                                value={watch("timeOut") ? dayjs(`2024-01-01T${watch("timeOut")}:00`) : null}
                                onChange={(newTime) => setValue("timeOut", newTime?.format("HH:mm") || "")}
                                disabled={disabled}
                                ampm={false}
                                slotProps={{
                                    textField: {
                                        size: "small",
                                        fullWidth: true
                                    }
                                }}
                            />
                        </td>


                        {["seenAt", "staffInitials", "referredTo", "supervised"].map((fieldName, index) => (
                            <td key={fieldName} style={{ padding: "8px" }}>
                                <TextField
                                    {...register(fieldName)}
                                    size="small"
                                    disabled={disabled}
                                    error={!!errors[fieldName]}
                                    inputProps={fieldName === "staffInitials" ? { style: { textTransform: "uppercase" } } : {}}
                                    fullWidth
                                />
                            </td>
                        ))}


                        {/* Dynamic checkboxes based on survey sections 
                        Control is an object to manage form state and behavior*/}
                        {dynamicFields.map(({ fieldName, sectionIndex, fieldIndex }: { fieldName: string; rawFieldName: string; sectionIndex: number; fieldIndex: number }) => 
                        
                        sectionIndex !== 0 && (

                            <td key={`section-${sectionIndex}-field-${fieldIndex}`} style={{ textAlign: "center" }}>
                                <Controller
                                    name={fieldName}
                                    control={control}
                                    defaultValue={false}
                                    render={({ field }) => (
                                        <Checkbox
                                            {...field}
                                            checked={field.value || false}
                                            disabled={disabled}
                                            size="small"
                                        />
                                    )}
                                />
                            </td>
                        ))}

                    </tr>
                </tbody>
            </table>
        </StyledPaper>
    );
}
